import {
  FB_LIST_ALL,
  FB_LIST_CREATE,
  FB_LIST_DELETE,
  FB_LIST_GET,
  FB_LIST_UPDATE,
  FB_LIST_ERROR,
} from "../../actions/types"

const initialState = {
  roomtypes: null,
  isLoading: false,
}
export default function FBOrderListReducer(state = initialState, action) {
  switch (action.type) {
    case FB_LIST_ALL:
      return {
        arr: action.payload?.rows,
        currPage: action.payload?.currPage,
        lastPage: action.payload?.lastPage,
        isLoading: true,
        total: action.payload?.total,
      }
    case FB_LIST_GET:
      return {
        ...action.payload,
        isLoading: true,
      }
    case FB_LIST_CREATE:
      return { isLoading: false }
    case FB_LIST_UPDATE:
      return { isLoading: false }
    case FB_LIST_DELETE:
      return { isLoading: false }
    case FB_LIST_ERROR:
      return { isLoading: false }
    default:
      return state
  }
}
